import React, { useEffect, useState } from "react";
import { Typography, Button, Box, Paper, Divider, Grid } from "@mui/material";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import FuseLoading from "@fuse/core/FuseLoading";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { getReportById, selectReportById } from "../store/reportSlice";

const ViewReportRoomDrowsiness = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const { reportId } = params;

  const report = useSelector((state) => selectReportById(state, reportId));
  const [groupedAnswers, setGroupedAnswers] = useState([]);

  useEffect(() => {
    if (report) {
      const grouped = report.answers.reduce((acc, item) => {
        const category = item.question_name?.trim() || "Sin categoría";
        const subIndex = item.subform_index ?? 0;

        if (category == "Hospedaje Taltal") return acc;

        if (!acc[category]) acc[category] = {};
        if (!acc[category][subIndex]) acc[category][subIndex] = [];

        acc[category][subIndex].push(item);
        return acc;
      }, {});

      const result = Object.entries(grouped).map(([category, subforms]) => ({
        category,
        subforms: Object.entries(subforms).map(([subIndex, items]) => ({
          subform_index: subIndex,
          items,
        })),
      }));

      setGroupedAnswers(result);
    }
  }, [report]);

  useEffect(() => {
    dispatch(getReportById(reportId));
  }, [dispatch, reportId]);

  if (!report) return <FuseLoading />;

  const handleBack = () => history.back();

  return (
    <Box p={3}>
      {/* 🔙 Volver */}
      <Button
        style={{ marginBottom: "10px" }}
        variant="contained"
        color="info"
        onClick={handleBack}
        size="small"
        startIcon={
          <FuseSvgIcon size={20}>material-solid:arrow_back</FuseSvgIcon>
        }
      >
        Volver
      </Button>

      {/* 🧾 Encabezado */}
      <Typography
        variant="h4"
        align="center"
        gutterBottom
        sx={{ fontWeight: "bold", color: "primary.main" }}
      >
        {report.name}: {report.code}
      </Typography>
      <Typography align="center" variant="subtitle1" gutterBottom>
        Realizada por <strong>{report.user_name}</strong>
      </Typography>

      {/* <Button
        variant="outlined"
        size="small"
        color="primary"
        sx={{ mb: 3 }}
        onClick={() => exportImagesReport(report, groupedAnswers)}
      >
        Exportar PDF
      </Button> */}

      {/* 📋 Render de Categorías */}
      {groupedAnswers.map((category, ci) => (
        <Paper key={ci} elevation={3} sx={{ p: 4, mt: 4, borderRadius: 3 }}>
          <Typography
            variant="h5"
            gutterBottom
            sx={{ fontWeight: "bold", color: "primary.main", mb: 3 }}
          >
            {category.category}
          </Typography>

          {/* 🔹 Subgrupos (por habitación o índice) */}
          {category.subforms.map((subform, si) => (
            <Box
              key={si}
              sx={{
                mb: 4,
                p: 3,
                borderRadius: 2,
                backgroundColor: si % 2 === 0 ? "grey.50" : "white",
                borderTop: "4px solid",
                borderColor: "primary.light",
              }}
            >
              <Typography
                variant="h6"
                gutterBottom
                sx={{ fontWeight: "bold", color: "secondary.main", mb: 2 }}
              >
                {category.category.includes("Habitación")
                  ? `Habitación ${parseInt(subform.subform_index) + 1}`
                  : `Grupo ${parseInt(subform.subform_index) + 1}`}
              </Typography>

              {/* 🧾 Listado de preguntas dentro del subgrupo */}
              {subform.items.map((item, i) => (
                <Box key={item.id} sx={{ mb: 3 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "bold", mb: 1 }}
                  >
                    {i + 1}. {item.name}
                  </Typography>

                  {/* Mostrar respuesta según tipo */}
                  {item.question_type === "photo" ? (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        flexWrap: "wrap",
                        gap: 2,
                      }}
                    >
                      <img
                        src={item.question_value}
                        alt={item.name}
                        style={{
                          maxWidth: "400px",
                          width: "100%",
                          height: "auto",
                          borderRadius: "10px",
                          boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                          cursor: "pointer",
                          transition: "transform 0.2s ease-in-out",
                        }}
                      />
                    </Box>
                  ) : (
                    <Typography variant="body1" sx={{ ml: 1 }}>
                      {item.question_value || "—"}
                    </Typography>
                  )}

                  <Divider sx={{ mt: 2 }} />
                </Box>
              ))}
            </Box>
          ))}
        </Paper>
      ))}
    </Box>
  );
};

export default ViewReportRoomDrowsiness;
